import { render, staticRenderFns } from "./ResolutionsCatalogs.vue?vue&type=template&id=5526b7d2&"
import script from "./ResolutionsCatalogs.vue?vue&type=script&lang=js&"
export * from "./ResolutionsCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports